// @flow
import { pictonBlue } from '../colors';
export var shadow1 = 'box-shadow: 0 0.3rem 1rem rgba(0, 0, 0, 0.07);';
export var shadow2 = 'box-shadow: 0 0.6rem 1rem rgba(0, 0, 0, 0.07);';
export var shadow3 = 'box-shadow: 0 1.0rem 2rem rgba(0, 0, 0, 0.07);';
export var shadow4 = 'box-shadow: 0 1.4rem 2.8rem rgba(0, 0, 0, 0.1);';
export var shadow5 = 'box-shadow: 0 1.9rem 3.8rem rgba(0, 0, 0, 0.15);';
export var shadow6 = 'box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.16);';
export var focus = "box-shadow: 0 0 1rem " + pictonBlue() + ";";
export var ecoShadow = 'box-shadow: 0.6rem 0.6rem 1.6rem rgba(209, 205, 199, 0.5), -0.6rem -0.6rem 1.6rem rgba(255, 255, 255, 0.75);'; // eslint-disable-line max-len